var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button",attrs:{"to":"/","id":"search"}},[_c('span',{staticClass:"button-text"},[_vm._v("Search again")]),_c('span',{staticClass:"button-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }